import AvailabilityWatchListClient from '../clients/AvailabilityWatchListClient';
import AbstractPilsComponent from './abstract-pils-component';
import pilsTypes from './pils-types';

export default class ToWatchListButton extends AbstractPilsComponent
{
    constructor(element)
    {
        super(element, pilsTypes.watchlist);

        this._loadingClass = 'loading';

        this._checkbox = element.parentElement.querySelector('.js-to-watch-list-checkbox');

        this._api = new AvailabilityWatchListClient();

        this.init();
    }

    init()
    {
        super.init();

        this.initEvents();
    }

    initEvents()
    {
        this._element.addEventListener(
            'click',
            this.handleButtonClick.bind(this)
        );
    }

    handleButtonClick()
    {
        this._element.classList.add(this._loadingClass);

        if (!this._checkbox.checked)
        {
            this._api.addProductNumberToWatchList(
                this._productNumber
            ).then(() =>
            {
                this._element.classList.remove(this._loadingClass);

                this._checkbox.checked = true;
            });
        }
        else
        {
            this._api.removeProductNumberFromWatchList(
                this._productNumber
            ).then(() =>
            {
                this._element.classList.remove(this._loadingClass);

                this._checkbox.checked = false;
            });
        }
    }

    update(data)
    {
        if (
            data[this._productNumber] &&
			data[this._productNumber][this._pilsType]
        )
        {
            this._checkbox.checked = true;
            return;
        }

        this._checkbox.checked = false;
    }
}
